export const CONTACT = {
  PHONE: "+36 30 300 3348",
  PHONELINK: "+36303003348",
  EMAIL: "automentes@soskincsem.hu",
};
